
import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink, Eye, RefreshCw } from 'lucide-react';

type RequestCardActionsProps = {
  type: 'sent' | 'received';
  status: string;
  feedbackId: string | null;
  onRespond: () => void;
  onViewFeedback: () => void;
  onSendReminder?: () => void;
  disableReminder?: boolean;
  isReminding?: boolean;
};

export const RequestCardActions = ({ 
  type, 
  status, 
  feedbackId, 
  onRespond, 
  onViewFeedback,
  onSendReminder,
  disableReminder,
  isReminding
}: RequestCardActionsProps) => {
  return (
    <div className="mt-4 md:mt-0 md:ml-4 md:min-w-[120px] flex md:flex-col items-center md:items-end gap-2">
      {/* Bouton pour répondre aux demandes reçues en attente */}
      {type === 'received' && status === 'pending' && (
        <Button 
          className="w-full md:w-auto"
          onClick={onRespond}
        >
          <ExternalLink size={16} className="mr-1" />
          Répondre
        </Button>
      )}
      
      {/* Bouton pour relancer une demande envoyée en attente */}
      {type === 'sent' && status === 'pending' && onSendReminder && (
        <Button
          variant="outline"
          className="w-full md:w-auto"
          onClick={onSendReminder}
          disabled={disableReminder || isReminding}
        >
          {isReminding ? (
            <span className="h-4 w-4 mr-2 rounded-full border-2 border-current border-r-transparent animate-spin" />
          ) : (
            <RefreshCw size={16} className="mr-1" />
          )}
          Relancer
        </Button>
      )}
      
      {/* Bouton pour voir le feedback (pour les demandes complétées) */}
      {(status === 'completed' || status === 'answered') && feedbackId && (
        <Button 
          variant={type === 'received' ? "outline" : "default"}
          className="w-full md:w-auto"
          onClick={onViewFeedback}
        >
          <Eye size={16} className="mr-1" />
          Voir le feedback
        </Button>
      )}
      
      {/* Bouton pour voir les détails d'une demande en attente */}
      {status === 'pending' && (
        <Button 
          variant="outline"
          className="w-full md:w-auto"
          onClick={onViewFeedback}
        >
          <Eye size={16} className="mr-1" />
          Voir les détails
        </Button>
      )}
    </div>
  );
};
